import { render } from "./ModelOverview.vue?vue&type=template&id=31aca6fd"
import script from "./ModelOverview.vue?vue&type=script&lang=js"
export * from "./ModelOverview.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__